var map = {
	"./0EF703BA-AAE5-4e21-BDC5-A3DD49D21A97.png": "db03",
	"./22.png": "2a2b",
	"./AIphoto": "2ab7",
	"./AIphoto.png": "2039",
	"./Adaptability.png": "eb21",
	"./AiphotoNo.png": "7414",
	"./All.png": "4edc",
	"./Anvisionlogo.png": "cbbc",
	"./AnxunLogo.png": "9dea",
	"./CPU.png": "be66",
	"./CPU_white.png": "a18a",
	"./Circle.png": "cfd9",
	"./Community.png": "b6b1",
	"./Education experience.png": "80f4",
	"./Element.png": "78b0",
	"./Ellipse 1 (Stroke).png": "635c",
	"./Ellipse 2 (Stroke).png": "7b95",
	"./Frame1171277103.png": "cd27",
	"./Frame1171277103Mobile.png": "34cc",
	"./GPTLOGO.png": "b021",
	"./GPTplant.png": "2f9e",
	"./Gradient.png": "416a",
	"./Gradient2.png": "2872",
	"./Inspection1.png": "d5ab",
	"./Inspection11.png": "af5d",
	"./Inspection12.jpg": "480b",
	"./Inspection12.png": "78c9",
	"./Inspection13.png": "82bb",
	"./Inspection2.png": "db53",
	"./Inspection21.jpg": "9d34",
	"./Inspection22.jpg": "fda4",
	"./Inspection23.jpg": "0ca8",
	"./Inspection3.png": "2028",
	"./Inspection31.png": "87f1",
	"./Inspection32.png": "fe2e",
	"./Inspection33.png": "35d7",
	"./Inspection4.png": "dd65",
	"./Inspection5.png": "43ca",
	"./Inspection6.png": "ed1e",
	"./Intelligence.png": "933f",
	"./Lumen5-PrimaryLogo.png": "6d80",
	"./Management.png": "6867",
	"./MidJourney-copy.png": "a5d9",
	"./Numerous.png": "47bb",
	"./OM1.png": "0076",
	"./OM11.png": "d59a",
	"./OM12.png": "a6bd",
	"./OM13.png": "80ac",
	"./OM14.png": "0a25",
	"./OM2.png": "e051",
	"./OM3.png": "3f26",
	"./OM4.png": "e095",
	"./Planning1.png": "f25c",
	"./SN0177-09.xlsx": "e913",
	"./SN0177-092.xlsx": "7152",
	"./Talent.png": "0c9d",
	"./TikTok.png": "42d9",
	"./Transparency.png": "a646",
	"./Vector.png": "6d23c",
	"./Visualization1.png": "0536",
	"./Visualization11.png": "6dd2",
	"./Visualization12.png": "48dc",
	"./Visualization13.png": "eca0",
	"./Visualization14.png": "852a",
	"./Visualization2.png": "dc20",
	"./Visualization21.png": "c15b",
	"./Visualization22.png": "3668",
	"./Visualization23.png": "67af",
	"./Visualization24.png": "6337",
	"./Visualization25.png": "8789",
	"./Visualization26.png": "8724",
	"./Visualization3.png": "17b7",
	"./Visualization4.png": "04b6",
	"./Visualization5.png": "da4a",
	"./Visualization6.png": "974f",
	"./Youtube.jpg": "bdc7",
	"./adv1.jpg": "f11d",
	"./adv1.png": "9fb6",
	"./adv2.jpg": "d54f",
	"./adv2.png": "f087",
	"./adv3.jpg": "5b2f",
	"./adv3.png": "82ae",
	"./adv4.png": "7423",
	"./advModel1.png": "a655",
	"./advModel2.png": "17d7",
	"./advModel3.png": "061b",
	"./advantage.png": "004b",
	"./aiBg.png": "13b4",
	"./aiBg2.png": "dcd7",
	"./alarm1.png": "793e",
	"./alarmopen.png": "3ecb",
	"./analysis1.png": "3c4a",
	"./analysis2.png": "7caa",
	"./analysis4.png": "b144",
	"./ancunu06.png": "32ec",
	"./anslysis3.png": "1383",
	"./antonoil.png": "0142",
	"./antontong.png": "5910",
	"./anxun.png": "9a99",
	"./anxun08.png": "c525",
	"./anxun1.png": "597e",
	"./anxun11.jpg": "a1fd",
	"./anxun11.png": "55a3",
	"./anxun112.jpg": "ddd0",
	"./anxun12 - 副本.png": "bbcf",
	"./anxun12.png": "766b",
	"./anxun13.png": "301a",
	"./anxun14.png": "65b8",
	"./anxun2.png": "a112",
	"./anxun21.png": "8fc5",
	"./anxun21new.png": "7e55",
	"./anxun21new1.png": "7355",
	"./anxun21new2.png": "a8ab",
	"./anxun21new3.png": "e819",
	"./anxun21new4.png": "4bf3",
	"./anxun22.png": "09ac",
	"./anxun23.png": "31fb",
	"./anxun3.png": "b77a",
	"./anxun31.png": "8376",
	"./anxun32.png": "bb65",
	"./anxun33.png": "722a",
	"./anxun4.png": "e1dc",
	"./anxun41.png": "5250",
	"./anxun42.png": "a79b",
	"./anxun43.png": "f963",
	"./anxun44.png": "fc56",
	"./anxun51.png": "85d1",
	"./anxun52.png": "95ea",
	"./anxun53.png": "ad20",
	"./anxun61.png": "a961",
	"./anxun62.png": "3f0f",
	"./anxun63.jpg": "8ccf",
	"./anxun63.png": "5525",
	"./anxun7.png": "5a25",
	"./anxun71.png": "42a6",
	"./anxun81.png": "a7b7",
	"./anxun82.png": "f5b1",
	"./anxun83.png": "366d",
	"./anxun84.png": "28bc",
	"./anxun91.png": "ed6a",
	"./anxunCompang.png": "8cc4",
	"./anxunMobel11.png": "6681",
	"./anxunMobel12.png": "16ad",
	"./anxunMobel21.png": "06f5",
	"./anxunMobel22.png": "7882",
	"./anxunMobel23.png": "f4d3",
	"./anxunMobel24.png": "13a7",
	"./anxunMobile13.png": "a921",
	"./anxunModel31.png": "906b",
	"./anxunSlogn.png": "0f62",
	"./anxunu01.png": "3710",
	"./anxunu01.svg": "1636",
	"./anxunu02.png": "a8d8",
	"./anxunu02.svg": "c2aa",
	"./anxunu03.svg": "7eec",
	"./anxunu04.png": "0a31",
	"./anxunu04.svg": "7fbf",
	"./anxunu05.svg": "203f",
	"./anxunu06.png": "59f0",
	"./anxunu06.svg": "3910",
	"./anxunu07.png": "0f8c",
	"./anxunu07.svg": "550f",
	"./anxunu08.png": "acb7",
	"./anxunu08.svg": "03bf",
	"./anxunu09.png": "4b48",
	"./anxunu09.svg": "b1e5",
	"./anxunu10.png": "cda4",
	"./anxunu10.svg": "ba69",
	"./application1.png": "21d6",
	"./application2.png": "12b2",
	"./application3.png": "1e17",
	"./application4.png": "d440",
	"./applicationBanner.png": "b741",
	"./arrow.png": "c5d4",
	"./arrow2.png": "e00c",
	"./arrow2_left.png": "2209",
	"./arrow2_right.png": "3ca6",
	"./arrow_blue.png": "fb05",
	"./arrow_eb7c31.png": "bb4b",
	"./arrow_right_blue.png": "8a06",
	"./arrows.png": "e7c9",
	"./assisted1.png": "0e5d",
	"./attention.png": "2e3b",
	"./automation.png": "a4a8",
	"./automationBanner.png": "aa18",
	"./automationnew.png": "0e19",
	"./avator.png": "21dc",
	"./ax-success/control1.png": "d104",
	"./ax-success/control2.png": "6c48",
	"./ax-success/drilling1.png": "ff56",
	"./ax-success/drilling2.png": "1536",
	"./ax-success/newenergy1.png": "8f4d",
	"./ax-success/newenergy2.png": "a61c",
	"./ax-success/pipline1.png": "e30b",
	"./ax-success/pipline2.jpeg": "84c1",
	"./ax-success/product1.png": "cf28",
	"./ax-success/product2.png": "f9dc",
	"./ax-success/refining1.png": "f81c",
	"./ax-success/reservoir1.jpeg": "742a",
	"./ax-success/reservoir2.jpeg": "0e49",
	"./ax-success/security1.png": "9dc6",
	"./ax-success/security2.jpeg": "a089",
	"./ax-success/station1.png": "692f",
	"./ax-success/station2.png": "965b",
	"./ax-success/station3.png": "a683",
	"./ax-success/wellbore1.png": "c0ff",
	"./axun22.png": "87c2",
	"./back.png": "336c",
	"./back1.jpg": "0e07",
	"./back1.png": "e665",
	"./backModel.jpg": "b302",
	"./background1.png": "cab4",
	"./background2.png": "bfe3",
	"./banner.png": "ec24",
	"./banner1.png": "f0b4",
	"./banner2.png": "c288",
	"./banner3.png": "fd31",
	"./banner4.png": "431a",
	"./banner5.png": "966a",
	"./banner6.png": "bbf7",
	"./banner7.png": "126a",
	"./banner8.png": "8e9c",
	"./banner9.png": "7ff3",
	"./bannerModel.png": "8b76",
	"./basic01.jpg": "cbee",
	"./basic01.png": "fbf4",
	"./basic02.jpg": "6d21",
	"./basic02.png": "14db",
	"./basic03.png": "06e6",
	"./basic04.png": "72df",
	"./basicmobilenew1.png": "382b",
	"./basicnew1.png": "48f0",
	"./beian.png": "1048",
	"./bgmodel.png": "cbdd",
	"./bigmodel.png": "4c65",
	"./bigmodel_white.png": "0758",
	"./bottom.jpg": "c941",
	"./build01.png": "7ec3",
	"./build02.png": "cede",
	"./build1.png": "3a2d",
	"./build2.jpeg": "cfea",
	"./build3.png": "5dd3",
	"./build4.png": "1952",
	"./build5.png": "276d",
	"./build6.png": "e84c",
	"./buildnew.png": "8af1",
	"./buildsucesse.jpg": "920f",
	"./buildsucesse.png": "8cc8",
	"./business.png": "e7f1",
	"./business_white.png": "d27e",
	"./button.png": "675d",
	"./charge1.png": "2fc3",
	"./charge2.png": "6932",
	"./charge3.png": "21cc",
	"./charge4.png": "afb0",
	"./charge5.png": "e5db",
	"./circlr.png": "bcd6",
	"./clock.png": "2b5f",
	"./colordown.png": "d237",
	"./combin.png": "6974",
	"./comelogo.png": "f7729",
	"./comment.png": "6ae1",
	"./communicate.png": "858f",
	"./companyBackground.png": "a4dd",
	"./companyBackground1.png": "0c80",
	"./companyBackground2.png": "d176",
	"./companyBackground4.png": "c04c",
	"./complex.png": "a5a5",
	"./construct1.png": "070b",
	"./construct2.png": "be4f",
	"./construct3.png": "3fab",
	"./construct4.png": "0b90",
	"./constructBanner.png": "6ac1",
	"./constructBannera.png": "3892",
	"./constructnew1.png": "3857",
	"./consult1.png": "5120",
	"./cost.png": "d18d",
	"./data1.png": "eb98",
	"./dataAnalysis1.png": "f63f",
	"./dataAnalysis2.png": "a291",
	"./database.png": "a27e",
	"./deeplearning.png": "fbd2",
	"./deepseek.png": "6826",
	"./deny.png": "c877",
	"./denyReally.png": "621a8",
	"./desicion1.png": "1459",
	"./desicionB.png": "4fd7",
	"./design.png": "4788",
	"./design2.png": "8049",
	"./designBanner.png": "7bd2",
	"./designnew.png": "7e5e",
	"./dianshang.png": "144c",
	"./dianshang1.png": "c28b",
	"./digital01.png": "e228",
	"./digital02.png": "5c7b",
	"./digital03.png": "bc68",
	"./dou.png": "a6d7",
	"./douyin.png": "52f8",
	"./drilling01.png": "5c9d8",
	"./drilling02.png": "94e3",
	"./drilling03.png": "abc12",
	"./drilling04.png": "0e81",
	"./drilling1.png": "4837",
	"./drilling11.png": "3a82",
	"./drilling2.png": "1379",
	"./duomeiti.png": "e0b6",
	"./earth2.png": "dd1b",
	"./efficiency.png": "b53f",
	"./enterprence1.png": "49d5",
	"./enterprenceBanner.png": "2a49",
	"./enterprise.png": "4d81",
	"./environment.png": "82c2",
	"./equ1.png": "fe2d",
	"./equ1a.png": "7fcd",
	"./equ2.jpg": "a92b",
	"./equ2.png": "7b5d",
	"./equ3.png": "5103",
	"./equ4.png": "43de",
	"./equ5.jpg": "8363",
	"./equ5.png": "1a5d",
	"./equipment1.png": "256b",
	"./equipment1new.png": "2711",
	"./equipment2.png": "6dff",
	"./equipment2new.png": "a7d7",
	"./equipment3new.png": "8c51",
	"./equipment4new.png": "e6cd",
	"./equipment5new.png": "3033",
	"./equipmentB.png": "8116",
	"./equipmentBack.png": "d82f",
	"./equipmentu1.webp": "c19d",
	"./equipmentu2.png": "a934",
	"./equipmentu2.webp": "3cb1",
	"./equipmentu3.webp": "0d57",
	"./equipmentu4.webp": "aa74",
	"./equup1.png": "1ac2",
	"./equup2.png": "773a",
	"./erp1.png": "c9df",
	"./erp2.png": "0f7f",
	"./error.png": "1fe8",
	"./erweima.png": "e2f2",
	"./exit.png": "4588",
	"./exploit1.png": "166d",
	"./exploit11.png": "654f",
	"./exploit12.png": "91f6",
	"./exploit13.png": "e443",
	"./exploit14.png": "854a",
	"./exploit15.png": "f517",
	"./exploit16.png": "5c0e",
	"./exploit17.png": "0b3c",
	"./exploit2.png": "7fb8",
	"./exploit3.png": "f838",
	"./exploit4.png": "c286",
	"./exploit5.png": "3f7a",
	"./exploit6.png": "c287",
	"./exploit7.png": "2a2c",
	"./expo.png": "8324",
	"./expoAi.png": "99cd",
	"./feedback.png": "f1fc",
	"./feedbackhome.jpg": "bfc1",
	"./fiber1.png": "53e0",
	"./fload.png": "a746",
	"./focusdown.png": "99ca",
	"./fonts/shangshou.ttf": "881a",
	"./foucs.png": "c89c",
	"./frack.png": "f3cb",
	"./frack01.png": "4bb1",
	"./frack02.png": "4480",
	"./frack1.png": "8074",
	"./frack2 .png": "9933",
	"./frack2.png": "6da9",
	"./frack3.png": "fc86",
	"./frack31.png": "380a",
	"./frack4.png": "5d86",
	"./frack5.png": "e4f2",
	"./frack6.png": "4f4d",
	"./frack7.png": "63ca",
	"./frackB.png": "df78",
	"./frackIcon1.png": "b89c",
	"./frackIcon2.png": "2ff8",
	"./frackIcon3.png": "09be",
	"./fuwu.jpg": "3347",
	"./fuwu.png": "ba77",
	"./ge.png": "94ce",
	"./gongzhonghao.jpg": "13e9",
	"./governance.png": "90bf",
	"./governance1.png": "c345",
	"./governance10.png": "7a67",
	"./governance11.png": "15e2",
	"./governance12.png": "edc9",
	"./governance13.png": "0999",
	"./governance2.png": "c9cc",
	"./governance3.png": "df30",
	"./governance4.png": "649e",
	"./governance5.png": "4949",
	"./governance6.png": "df71",
	"./governance7.png": "72f2",
	"./governance8.png": "803f",
	"./governance9.png": "e5d7",
	"./gpt1.jpg": "b05a",
	"./gpt11.jpg": "d0666",
	"./gpt12.jpg": "66e2",
	"./gpt13.png": "4052",
	"./gpt14.png": "7d01",
	"./gpt15.png": "ee29",
	"./gpt16.png": "3722",
	"./gpt2.jpg": "0a09",
	"./gpt21.png": "72e2",
	"./gpt22.jpg": "cec0",
	"./gpt23.png": "4bf4",
	"./gpt24.png": "a427",
	"./gpt25.png": "2afa",
	"./gpt26.png": "aec2",
	"./gpt3.jpg": "76fb",
	"./gpt31.png": "c2b7",
	"./gpt32.jpg": "86e3",
	"./gpt33.png": "521d",
	"./gpt34.png": "f48c",
	"./gpt35.png": "2ad2",
	"./gpt36.png": "1ca0",
	"./gpt4.jpg": "7161",
	"./gpt41.png": "d705",
	"./gpt42.jpg": "498a",
	"./gpt43.png": "646b",
	"./gpt44.png": "e51e",
	"./gpt45.png": "aa2a",
	"./gpt46.png": "5843",
	"./gpt5.jpg": "923b",
	"./gpt51.png": "2bd5",
	"./gpt52.jpg": "9b7b",
	"./gpt53.png": "1486",
	"./gpt54.png": "7e15",
	"./gpt55.png": "fb0e",
	"./gpt56.png": "c303",
	"./gpt6.jpg": "deaa",
	"./gpt61.png": "1a32",
	"./gpt62.jpg": "2fe8",
	"./gpt63.png": "76df",
	"./gpt64.png": "2fc2",
	"./gpt66.png": "6856",
	"./gpt7.jpg": "6609",
	"./gpt71.png": "2ce3",
	"./gpt72.jpg": "a6c6",
	"./gpt73.png": "4267",
	"./gpt74.png": "50c3",
	"./gpt75.png": "ca87",
	"./gpt76.png": "8def",
	"./gptModel11.png": "ab98",
	"./gptModel12.png": "431c",
	"./gptModel21.png": "ef93",
	"./gptModel22.png": "3e11",
	"./gptModel31.png": "47cb",
	"./gptModel32.png": "e0cf",
	"./gptModel41.png": "856c",
	"./gptModel42.png": "25c3",
	"./gptModel51.png": "5554",
	"./gptModel52.png": "b84a",
	"./gptModel53.png": "729d",
	"./gptModel61.png": "7b50",
	"./gptModel62.png": "efea",
	"./gptModel71.png": "f579",
	"./gptModel72.png": "2a4e",
	"./gptnew1.png": "a326",
	"./gptnew2.png": "7c75",
	"./gptnew3.png": "eacc",
	"./gptzixun.png": "3700",
	"./ground1.png": "846e",
	"./ground1a.png": "681c",
	"./ground2.png": "fb30",
	"./ground3.png": "7499",
	"./ground31.png": "19c6e",
	"./ground4.png": "b127",
	"./ground5.png": "8f29",
	"./ground6.png": "0572",
	"./ground7.png": "e88a",
	"./ground8.png": "0d6c",
	"./ground9.png": "5b6f",
	"./groundB.png": "9186",
	"./groundD1.png": "74ee",
	"./groundD2.png": "1c23",
	"./groundHome14.png": "dfda",
	"./groundabou10t.png": "bbf0",
	"./groundabout.png": "8a18",
	"./groundabout11.png": "30d2",
	"./groundabout2.webp": "6809",
	"./groundabout3.png": "beb2",
	"./groundabout4.png": "8aeb",
	"./groundabout5.png": "679d",
	"./groundabout6.png": "1754",
	"./groundabout7.png": "953c",
	"./groundabout8.jpg": "5f1c",
	"./groundabout8.png": "f227",
	"./groundabout9.png": "b593",
	"./guanli.png": "3ce2",
	"./guanwang1.png": "da95",
	"./guanwang100.png": "ec24b",
	"./guanwang11.png": "2e47",
	"./guanwang2.png": "42b8",
	"./guanwang22.png": "1428",
	"./guanwang23.png": "0382",
	"./guanwang23.png.jpg": "5d2f",
	"./guanwang3.png": "3983",
	"./guanwang4.png": "f18d",
	"./guidance1.png": "55a5",
	"./guidance1.webp": "7192",
	"./guidance11.png": "8696",
	"./guidance111.png": "dd22",
	"./guidance12.png": "281c",
	"./guidance13.png": "6a66",
	"./guidance14.png": "1101",
	"./guidance2.webp": "bf31",
	"./guidance3.webp": "1f65",
	"./guidance4.webp": "d03d",
	"./guidance5.webp": "93fd",
	"./guidance6.webp": "4261",
	"./guidance7.webp": "bfc6",
	"./hand.png": "594f",
	"./hezuo.jpg": "ad4d",
	"./home/control.jpeg": "103d",
	"./home/icon/icon1.png": "e271",
	"./home/icon/icon2.png": "0ef4",
	"./home/icon/icon3.png": "ca22",
	"./home/icon/icon4.png": "1021",
	"./home/icon/icon5.png": "9521",
	"./home/wellbore.jpeg": "869b",
	"./home1.png": "2fce",
	"./home11.png": "924a",
	"./home2.png": "517f",
	"./home3.png": "d807",
	"./home4.png": "d6bb",
	"./home5.png": "a856",
	"./home6.png": "80d5",
	"./home7.png": "88be",
	"./home8.png": "98af",
	"./home9.png": "e548",
	"./homeNavigation1.png": "0f48",
	"./homeNavigation2.png": "e258",
	"./homeNavigation3.png": "bc0e",
	"./homeNavigation4.png": "980f",
	"./homeNavigation5.png": "9af4",
	"./homeNavigation6.png": "87a5",
	"./homeSend.png": "cbe7",
	"./homeSendNo.png": "b274",
	"./home_send2.png": "3914",
	"./homebanner2.jpg": "2997",
	"./hot.png": "15ea",
	"./hummer.png": "ee8c",
	"./icon-01.png": "f79c",
	"./icon-02.png": "a2a6",
	"./icon-03.png": "75af",
	"./icon-04.png": "049c",
	"./icon-05.png": "02ef",
	"./icon-06.png": "1a4a",
	"./icon-07.png": "8f29a",
	"./icon-08.png": "7764",
	"./icon-09.png": "77be",
	"./icon-10.png": "92a9",
	"./icon-11.png": "ac6b",
	"./icon-12.png": "4a0a",
	"./icon-13.png": "90a7",
	"./icon01.png": "c0a4",
	"./icon02.png": "0582",
	"./icon03.png": "f848",
	"./icon04.png": "0f38",
	"./icon05.png": "4992",
	"./icon06.png": "52b8",
	"./icon07.png": "2459",
	"./icon08.png": "84fb",
	"./icon09.png": "cfc2",
	"./icon10.png": "0359",
	"./icon11.png": "dad1",
	"./icon12.png": "ece4",
	"./icon13.png": "4279",
	"./icon14.png": "3bf3",
	"./icon15.png": "3c34",
	"./icon_first.png": "d331",
	"./icon_forth.png": "e891",
	"./icon_second.png": "3ca35",
	"./icon_third.png": "f997",
	"./img.png": "7e77f",
	"./img_1.png": "f85b",
	"./img_2.png": "f731",
	"./img_3.png": "8d95",
	"./img_4.png": "3c11",
	"./img_5.png": "7c41",
	"./img_6.png": "9032",
	"./img_7.png": "0166",
	"./img_8.png": "671b",
	"./img_9.png": "936f",
	"./info1.jpg": "7187",
	"./info2.jpg": "efc4",
	"./info3.jpg": "70a7",
	"./infoAi.png": "dacf",
	"./information.png": "19c6",
	"./injectionProduction.png": "4d08",
	"./injectionProductionBanner.png": "f3c7",
	"./innovation.png": "1c10",
	"./interface.png": "b95c",
	"./introduce1.png": "4e05",
	"./introduce2.png": "4118",
	"./java1.png": "38c8",
	"./jianshe.jpg": "f0ec",
	"./jianshe.png": "4c15",
	"./jinritoutiao.png": "9865",
	"./job.png": "1839",
	"./jobAi.png": "703a",
	"./kaifa.png": "cf86",
	"./kefu.png": "cce9",
	"./kefu2 (1).png": "f923",
	"./kefu2.png": "6399",
	"./kefu3.png": "5d6f4",
	"./knowledge.png": "b2bd",
	"./knowledge2.png": "1a0d",
	"./knowledgeBanner.png": "dd2e",
	"./knowledgeicon.png": "fed6",
	"./knowledgeicon_white.png": "fa85",
	"./knowledgenew.png": "f88f",
	"./knowledgenew1.jpg": "b80c",
	"./knowledgenew2.png": "5c79",
	"./knowledgenew3.jpg": "25ed",
	"./knowledgenew4.png": "3834",
	"./knowledgenew5.jpg": "d41a",
	"./knowledgenew5.png": "f5fb",
	"./knowledgenew6.jpeg": "d119",
	"./knowledgenew6.png": "50f3",
	"./knowledgethis.png": "ba8b",
	"./late.png": "8859",
	"./left_white.png": "e413",
	"./light1.png": "319a",
	"./light2.png": "8712",
	"./lightB.png": "8f22",
	"./limit.png": "6dc0",
	"./lingying.png": "c311",
	"./linkedin.png": "dd32",
	"./linkin_blue.png": "a251",
	"./liucheng.png": "3798",
	"./liucheng1.png": "1055",
	"./logo1.png": "534f",
	"./logo2.png": "5fbe",
	"./logo3.png": "d092",
	"./logo4.png": "5c9d",
	"./logo5.png": "50f7",
	"./makehole1.png": "62f5",
	"./makehole2.png": "6b59",
	"./makehole3.png": "aee6",
	"./makehole4.png": "7955",
	"./makehole5.png": "ec47",
	"./makehole6.png": "5365",
	"./makehole7.png": "b96d",
	"./makehole8.png": "2809",
	"./managementicon.png": "7326",
	"./mediaCom.png": "556b",
	"./mediaCompany.png": "7ef3",
	"./mediaSlogin.png": "d759",
	"./meiti1.png": "b8da",
	"./meiti11.png": "1a54",
	"./meiti2.png": "2c7b",
	"./meiti22.png": "b1f9",
	"./meiti3.jpg": "50a5",
	"./meiti3.png": "1892",
	"./meiti33.png": "918b",
	"./meitinew2.png": "ccda",
	"./menage1.jpg": "b270",
	"./menage1.png": "5a0b",
	"./menage10.jpg": "f015",
	"./menage11.jpg": "05b8",
	"./menage12.jpg": "517fc",
	"./menage1a.png": "1728",
	"./menage1b.png": "95c4",
	"./menage2.jpg": "1262",
	"./menage3.jpg": "a2df",
	"./menage3.png": "5663",
	"./menage4.jpg": "d4f9",
	"./menage4.png": "d8ca",
	"./menage5.jpg": "daa4",
	"./menage5.png": "f867",
	"./menage6.png": "90ef",
	"./menage7.png": "88b6",
	"./menage8.jpg": "545b",
	"./menage8.png": "3b7f",
	"./menage9.jpg": "3632",
	"./menageBanner.png": "d6e6",
	"./menageService.png": "8607",
	"./menageService1.png": "5f7a",
	"./menageService11.png": "f157",
	"./menageService2.png": "3431",
	"./menageService3.png": "c090",
	"./menageService4.png": "89a0",
	"./menageService5.png": "05b6",
	"./menageService6.png": "4810",
	"./metinew1.png": "e074",
	"./mogu.jpg": "b2d9",
	"./monitior1.png": "6a44",
	"./monitiorB.png": "3925",
	"./monitiornew1.png": "13a0",
	"./monitiornew1.svg": "0c73",
	"./monitiornew2.webp": "0443",
	"./monitiornew3.webp": "b9ed",
	"./monitiornew4.webp": "4da0",
	"./monitiornew5.webp": "5654",
	"./monitiornew6.png": "4ade",
	"./monitiornew6.webp": "621b",
	"./monitor.png": "7fea",
	"./monitor01.png": "7201",
	"./monitor02.png": "184d",
	"./monitor03.png": "dac8",
	"./more_btn_icon.png": "da1f",
	"./more_btn_icon.png_black - 副本.png": "d88b",
	"./more_btn_icon.png_black.png": "6d23",
	"./more_btn_icon.png_white - 副本.png": "21e1",
	"./more_btn_icon.png_white.png": "c07a",
	"./more_btn_icon_ black.png": "d379",
	"./mouse.png": "4c2a",
	"./navigation1.png": "6bbc",
	"./navigationpoint.png": "b8de",
	"./net.png": "bde0",
	"./netModel.png": "ff43",
	"./network01.png": "ff19",
	"./network02.png": "5366",
	"./network03.png": "9237",
	"./new.png": "2596",
	"./news.png": "cd65",
	"./news1.png": "c3f1",
	"./news111.png": "e6e5",
	"./news112.png": "e4e1",
	"./news113.png": "c161",
	"./news114.png": "9d17",
	"./news2.png": "2c6f",
	"./news3.png": "363c",
	"./news4.png": "bc9e",
	"./oil1.png": "d23a",
	"./oil2.png": "4a1d",
	"./oil3.png": "d4f8",
	"./oil4.png": "54f5",
	"./oil5.png": "16ff",
	"./oil6.png": "0f75",
	"./oil7.png": "27be",
	"./oilApplication1.png": "af69",
	"./oilApplication2.png": "535a",
	"./oilApplication3.png": "5445",
	"./oilApplication4.png": "dc93",
	"./oilApplication5.png": "3c82",
	"./oilApplication6.png": "eb39",
	"./oilApplication7.png": "dc4f",
	"./oilApplicationBanner.png": "70b5",
	"./oilCompany.png": "3ae4",
	"./oilSlogin.png": "4eb2",
	"./oilba.png": "c5f2",
	"./oillight1.png": "c53e",
	"./oillight2.png": "d08e",
	"./oillight3.png": "49ce",
	"./oilserve1.png": "ee0f",
	"./onlineInfo.jpg": "230f",
	"./openclaw/ali.svg": "e78d",
	"./openclaw/baidu.svg": "ba90",
	"./openclaw/huawei.svg": "3cc8",
	"./openclaw/kimi.svg": "b545",
	"./openclaw/openclaw.png": "ee0b",
	"./openclaw/tengxun.svg": "30a5",
	"./openclaw/zijie.svg": "f67c",
	"./optimize.png": "9253",
	"./outHoverIcon.png": "c2b3",
	"./outIcon.png": "f202",
	"./peixun.jpg": "fa26",
	"./peixun.png": "3149",
	"./peixun1.png": "c9cd",
	"./peixun2.jpg": "36c0",
	"./peixun2.png": "92bd",
	"./peixunBanner.png": "223d",
	"./peixunBannera.png": "b3e6",
	"./pipeline_111.png": "de41",
	"./pipelinebenfit1.png": "82bbd",
	"./pipelinebenfit2.png": "f292",
	"./planning.png": "65d8",
	"./plat.png": "bc7c",
	"./plat2.png": "9581",
	"./platBanner.png": "a37d",
	"./platnew.png": "3d18",
	"./plug1.png": "e735",
	"./plug11.png": "21c9",
	"./plug2.png": "5af1",
	"./plug3.png": "5090",
	"./plug4.png": "e400",
	"./plug5.webp": "500b",
	"./plug6.webp": "0029",
	"./prediction.png": "79d2",
	"./pro1.jpg": "b7f9",
	"./pro1.jpg.png": "5da1",
	"./pro1.png": "0495",
	"./pro11.png": "67fd",
	"./pro12.png": "e2f9",
	"./pro13.png": "78fa",
	"./pro2.jpg": "1795",
	"./pro2.png": "7d6a",
	"./pro3.jpg": "b643",
	"./pro3.png": "25c7",
	"./pro4.jpg": "ff8d",
	"./pro4.png": "f3fe",
	"./pro5.jpg": "16d1",
	"./pro5.png": "8ceb",
	"./pro6.jpg": "4dc1",
	"./pro6.png": "3e22",
	"./pro7.jpg": "5695",
	"./pro7.png": "d694",
	"./product01.png": "e78d8",
	"./product02.png": "021f",
	"./product03.png": "8327",
	"./product1.png": "16ac",
	"./product1new.png": "4a6a",
	"./product2.png": "c7d4",
	"./product2new.png": "f1f8",
	"./product3.png": "6f23",
	"./product3new.png": "25ba",
	"./product3newmodel.png": "5f94",
	"./productu01.png": "26e0",
	"./productu02.png": "da66",
	"./productu03.png": "0264",
	"./productu04.png": "9135",
	"./professional.png": "6c8b",
	"./puji1.png": "0855",
	"./puji11.png": "02fd",
	"./puji2.jpg": "3331",
	"./puji22.png": "c3d8",
	"./qihangCompany.png": "ec11",
	"./qiye.png": "fefd",
	"./qiye1.png": "03e5",
	"./quick-fill.png": "42b8f",
	"./realtime.png": "bdaf",
	"./recognition1.png": "52b7",
	"./recognition2.png": "9984",
	"./recognitionB.png": "77e2",
	"./redpointer.cur": "40b3",
	"./redpointer.svg": "243a",
	"./rencai.png": "a641",
	"./rightArrow.png": "0e0b",
	"./right_circle.png": "67fa",
	"./right_white.png": "38c4",
	"./risk.png": "6690",
	"./safe.png": "5a42",
	"./secure1.png": "446b",
	"./secure2.png": "ed50",
	"./secure3.png": "1e2f",
	"./secure4.png": "d1cc",
	"./security01.png": "f583",
	"./security02.png": "0619",
	"./security03.png": "caf7",
	"./select.png": "aa42",
	"./send.png": "1959",
	"./sendno.png": "432e",
	"./serve1.png": "d98c",
	"./serve2.png": "a3a3",
	"./serve3.png": "da50",
	"./serve4.png": "5e0b",
	"./serve5.png": "682e",
	"./serve6.png": "57a5",
	"./serve7.png": "ed03",
	"./serve7Model.png": "cb47",
	"./serve8.png": "8a3d",
	"./serve8Model.png": "2da4",
	"./service1.png": "f434",
	"./service2.png": "5f91",
	"./service3.png": "0907",
	"./service4.png": "6213",
	"./service5.png": "9ba3",
	"./service6.png": "61f3",
	"./serviceBanner.png": "9b9b",
	"./servicesBanner1.png": "ddd62",
	"./servicesBanner2.png": "52cb",
	"./servicesBanner3.png": "4920",
	"./servocesBanner.png": "01a3",
	"./setingu1.png": "b5f0",
	"./setingu2.png": "05fc",
	"./setingu3.png": "729f",
	"./setingu4.png": "b37e",
	"./setingu5.png": "6b6f",
	"./setingu6.png": "60d1",
	"./settingsucesse1.jpg": "6ecd",
	"./settingsucesse1.png": "1251",
	"./settingsucesse11.png": "2503",
	"./settingsucesse2.jpg": "3d40",
	"./shuzhi.png": "ea6c",
	"./shuzhiCompany.png": "67f2",
	"./shuzhiSlogin.png": "11b8",
	"./shuzhiback.png": "b9bc",
	"./silos.png": "5240",
	"./slipleft.png": "9a73",
	"./smartControl1.png": "1453",
	"./smartControl11.png": "d7ef",
	"./smartControl12.png": "603d",
	"./smartControl13.png": "2a22",
	"./smartControl2.png": "818b",
	"./smartControl21.png": "5d43",
	"./smartControl22.jpg": "adc8",
	"./smartControl23.jpg": "a265",
	"./smartControl3.png": "071b",
	"./smartControlCore1.png": "7206",
	"./smartControlCore2.png": "f343",
	"./smartControlCore3.png": "9fc1",
	"./smartProduct1.png": "2660",
	"./smartProduct11.png": "5882",
	"./smartProduct12.png": "5b04",
	"./smartProduct13.png": "a87f",
	"./smartProduct14.png": "f7f4",
	"./smartProduct2.png": "fcb4",
	"./smartProduct21.png": "7560",
	"./smartProduct22.jpg": "abff",
	"./smartProduct23.png": "804d",
	"./smartProduct3.png": "f225",
	"./smartProduct31.png": "08ea",
	"./smartProduct4.png": "533d",
	"./smartProduct5.png": "2a40",
	"./smartstation1.png": "1cab",
	"./smartstation11.png": "b53a",
	"./smartstation12.png": "8eb3",
	"./smartstation13.png": "32db",
	"./smartstation21.png": "c1f5",
	"./smartstation22.png": "0342",
	"./smartstation23.png": "6878",
	"./smartstation41.png": "7d8a",
	"./smartstation42.png": "8e58",
	"./smartstation43.png": "a8d4",
	"./smartstation44.png": "dbbc",
	"./smartstation51.png": "a523",
	"./smartstation52.png": "0240",
	"./software/exploit/u2.webp": "7297",
	"./software/exploit/u26.webp": "0499",
	"./software/exploit/u27.webp": "1a70",
	"./software/exploit/u28.webp": "c9e0",
	"./software/exploit/u29.webp": "e9a8",
	"./software/exploit/u3.webp": "2b67",
	"./software/exploit/u35.webp": "3e63",
	"./software/exploit/u37.webp": "6cab",
	"./software/exploit/u4.webp": "9c00",
	"./software/om/benefit1.webp": "44c7",
	"./software/om/benefit2.webp": "6e08",
	"./software/om/benefit3.webp": "8f2d",
	"./software/om/security.webp": "daf7",
	"./software/om/system.webp": "f0f0",
	"./software/om/team.webp": "72d9",
	"./software1.png": "9634",
	"./software11.png": "4724",
	"./software12.png": "bf54",
	"./software13.png": "0240e",
	"./software14.png": "b74e",
	"./software15.png": "7c76",
	"./software16.png": "3c58",
	"./software2.png": "0b4b",
	"./software21.png": "e987",
	"./software22.png": "0935",
	"./software23.png": "6b80",
	"./software31.png": "be26",
	"./software32.png": "20f8",
	"./software33.png": "47d8",
	"./software34.png": "6edc",
	"./software35.png": "452e",
	"./span.png": "3a84",
	"./standards.png": "0e82",
	"./star.png": "6c8d",
	"./station01.png": "0ba8",
	"./station02.png": "8570",
	"./station03.png": "f4e1",
	"./station04.png": "a824",
	"./stationbenefit2.png": "a210",
	"./stationbenefit3.png": "f6da",
	"./stationbenefit4.png": "c852",
	"./storage01.png": "38a8",
	"./storage02.png": "f91e",
	"./storage03.png": "b84c",
	"./storage1.png": "3af5",
	"./storageConstruct.png": "cd07",
	"./storagebenefit2.png": "2934",
	"./storagebenefit3.png": "63d1",
	"./storagebenefit4.png": "0ffc",
	"./storagebenifit1.png": "1254",
	"./subcontract1.png": "86f9",
	"./subcontract11.png": "ef3b",
	"./subcontract12.png": "71ba",
	"./subcontract13.png": "f513",
	"./subcontract2.png": "aec4",
	"./subcontract3.png": "de4a",
	"./success1.png": "3b9e",
	"./success10.png": "a448",
	"./success11.png": "019b",
	"./success12.png": "572b",
	"./success13.png": "0462",
	"./success14.png": "f98b",
	"./success15.png": "820d",
	"./success16.png": "ac42",
	"./success17.png": "a11e",
	"./success2.png": "4115",
	"./success3.png": "7e2c",
	"./success4.png": "1ffd",
	"./success5.png": "e75d",
	"./success6.png": "60f0",
	"./success7.png": "6134",
	"./success8.png": "af02",
	"./success9.jpg": "ea9d",
	"./summarize.png": "6d5d",
	"./teamwork.png": "2ca8",
	"./technology01.png": "b2d4",
	"./technology02.png": "bfbc",
	"./technology03.png": "1920",
	"./technology04.png": "6c06",
	"./technologyu01.png": "e302",
	"./technologyu01.svg": "6f72",
	"./technologyu02.png": "e2b6",
	"./technologyu02.svg": "aa27",
	"./technologyu03.png": "5cc2",
	"./technologyu03.svg": "4f71",
	"./technologyu04.png": "f95a",
	"./technologyu04.svg": "648c",
	"./teng.png": "70b3",
	"./third1.png": "802c",
	"./third10.png": "30e4",
	"./third11.png": "66ea",
	"./third12.png": "cbdd0",
	"./third13.png": "ae94",
	"./third14.png": "57c8",
	"./third15.png": "2b83",
	"./third16.png": "b71a",
	"./third17.png": "2e0e",
	"./third18.png": "0984",
	"./third19.png": "a0ce",
	"./third2.png": "e5d4",
	"./third3.png": "deee",
	"./third4.png": "4cd2",
	"./third5.png": "30a8",
	"./third6.png": "b378",
	"./third7.png": "8186",
	"./third8.png": "0d67",
	"./third9.png": "d429b",
	"./three.png": "7849",
	"./tian.png": "82b9",
	"./tishi.png": "c294",
	"./tong.png": "55d4",
	"./training1.png": "537f",
	"./training11.jpg": "9ce6",
	"./trainingbenefit1.png": "748f",
	"./trainingbenefit2.png": "b7f0",
	"./trainingbenefit3.png": "9ee9",
	"./trainingbenefit4.png": "42c5",
	"./traning01.png": "d24e",
	"./traning02.png": "e5eb",
	"./traning03.png": "ff78",
	"./traning1.png": "9534",
	"./traning2.png": "e0d7",
	"./traning3.png": "e7ab",
	"./u0.png": "8845",
	"./u19.png": "954f",
	"./u23.png": "f3b9",
	"./u34.png": "1bee",
	"./up.png": "8219",
	"./up2.png": "cc77",
	"./up_arrow_white.png": "c5f6",
	"./user.jpg": "18d5",
	"./userBg.png": "67e5",
	"./userHoverIcon.png": "6ff9",
	"./userIcon.png": "69e6",
	"./vector1.png": "3260",
	"./vector2.png": "0440",
	"./vector3.png": "8e83",
	"./wan.png": "cfa7",
	"./web1.png": "7b8a",
	"./wechat.jpg": "e660",
	"./wen.png": "ef53",
	"./wisdom.png": "2d07",
	"./wisdom2.png": "9bec",
	"./wisdom3.png": "9b02",
	"./wisdomApply1.png": "e562",
	"./wisdomApply2.png": "2db8",
	"./wisdomApply3.png": "c4e6",
	"./wisdomBanner.png": "ddc2",
	"./wisdomZhili1.png": "2224",
	"./wisdomZhili2.png": "554c",
	"./wisdomZhili3.png": "5ab8",
	"./wisdomZhili4.png": "af87",
	"./wisdomZhili5.png": "8f68",
	"./wisdomZhili6.png": "3ce9",
	"./wisdomZhili7.png": "99f7",
	"./wisdomnew.png": "2084",
	"./wisdompain.png": "511f",
	"./wisdomsuccess1.png": "6faf",
	"./wisdomsuccess2.png": "8778",
	"./wisdomvalue.png": "8e91",
	"./xun.png": "19de",
	"./yi.png": "e615",
	"./yuangong.png": "49ac",
	"./yuangong1.png": "e767",
	"./zhi.png": "ac4a",
	"./zhihu.png": "8b23",
	"./zhihui.jpg": "34b5",
	"./zhihui.png": "4dae",
	"./zhihui1.png": "231c",
	"./zhinengzixun.png": "5b95",
	"./zhushihua.jpg": "5c17",
	"./zhushihua.png": "b18e",
	"./zhushihua1.png": "af68",
	"./zijian.jpg": "280e",
	"./zijian.png": "af16",
	"./zijian1.png": "a9e7",
	"./zijian2.png": "a0fa",
	"./zijian3.png": "87f5",
	"./zijian4.png": "1270",
	"./zijianCompany.jpg": "c942",
	"./zijianComputer.jpg": "6245",
	"./zijianMobel1.png": "2e4f",
	"./zijianPlat.jpg": "b4d2",
	"./zijianbusiness.jpg": "9b08",
	"./zixun.png": "3482",
	"./图片3.png": "b492",
	"./图片4.jpg": "ee63",
	"./油气通产品材料V0.3-English.pptx": "e8ab",
	"./演示文稿1.pptx": "5608",
	"./着陆段模拟数据样例.xlsx": "b150",
	"./翻译.pptx": "f892"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";